<template>
    <v-row>
        <v-col cols="6" md="4" v-for="(obj,i) in objectives" :key="i" class="py-2">
            <v-card class="kimsa-elevation" ripple @click="setObjective(obj.name)" :color="active(obj.name)">
                <v-img :src="obj.src" eager/>
                <div :class="['objective-label', activeText(obj.name)]">
                    {{ obj.name }}
                </div>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>

import {mapActions, mapState} from "vuex";

export default {
    props: {
        defaultObjective: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            objective: '',
        }
    },
    computed: {
        ...mapState(['config']),
        objectives(vm = this) {
            if (!vm.config) return []
            return vm.config.routineCategories.map(objective => {
                return {
                    name: objective.name,
                    value: objective.name,
                    src: objective.src,
                }
            })
        }
    },
    methods: {
        ...mapActions(['bindConfig']),
        setDefaults() {
            const vm = this
            if (vm.defaultObjective) {
                vm.objective = vm.defaultObjective
            }
        },
        setObjective(objective) {
            var vm = this
            vm.objective = objective
        },
        active(objective) {
            var vm = this
            return vm.objective === objective ? 'secondary' : 'white'
        },
        activeText(objective) {
            var vm = this
            return vm.objective === objective ? 'white--text' : ''
        }
    },
    mounted() {
        const vm = this
        vm.setDefaults()

        if (!vm.config) {
            vm.bindConfig()
        }
    },
    watch: {
        objective() {
            this.$emit('change', this.objective)
        },
    },
}
</script>

<style scoped>

.objective-label {
    color: #333333;
    font-size: 17px;
    font-weight: bold;
    padding: 5px;
    margin-left: 5px;
}

</style>